import { Flex } from '@acko-tech/building-blocks.ui.common'
import styled, { keyframes } from 'styled-components'

export const WidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 300px;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
`

export const Heading = styled.p`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: #121212;
  margin-bottom: 8px;
`

export const SubHeading = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  margin: 4px 0px;
  color: #4B4B4B;
`

export const StyledButton = styled.button`
  background: #121212;
  border: 1px solid #e7e7f0;
  border-radius: 8px;
  width: 100%;
  color: white;
  text-align: center;
  padding: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  &:active {
    background: #064625;
  }
`

export const CallBackIconWrapper = styled.div`
  text-align: center;
  img {
    width: 100%;
    height: 100%;
    min-height: 136px;
    object-fit: cover;
    object-position: left;
    border-radius: 8px;
  }
`

export const CallBackWidgetContainer = styled.div`
  position: sticky;
  top: 12%;
`

export const CallBackWidgetDesktopContainer = styled.div`
  margin-bottom: 14px;
  border: 1.5px solid #e0e0e8;
  border-radius: 12px;
  padding: 24px;
`
export const CallBackWidgetDesktopContainerPurple = styled(CallBackWidgetDesktopContainer)`
  background: #5920c5;
`

export const CallBackWidgetDesktopContainerPurpleMobile = styled(CallBackWidgetDesktopContainerPurple)`
  position: fixed;
  bottom: -2%;
  background-color: #fff;
  z-index: 101;
  width: 100%;
  color: #000;
`

export const MobileOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
`

// shimmer

const shimmerAnimation = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`

export const CallBackWidgetDesktopShimmerContainer = styled.div`
  margin-bottom: 14px;
  border-radius: 12px;
  padding: 48px;
  position: relative;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${shimmerAnimation} 1.5s infinite linear;
`

export const CallBackWidgetContainerMobile = styled.div`
  color: black;
  position: fixed;
  bottom: 6%;
  background: linear-gradient(91deg, #ebfbee 0%, #c1f5c8 100%);
  width: 100%;
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const WidgetMobileFloater = styled(Flex)`
  align-items: center;
  width: 100%;
  justify-content: space-around;
  color: #064625;
  z-index: 9;
`

export const CallbackPopupWrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
`
export const CallbackPopupContentWrapper = styled.div`
  @media(min-width:420px) {
    left: calc(50% - 210px);
  }
  background: white;
  position: sticky;
  top: 100%;
  width: 100%;
  border-radius: 24px 24px 0 0;
  padding: 24px;
  max-width: 420px;

  animation-name: animatetop;
  animation-duration: 0.3s;
  animation-timing-function: ease-in;
  @keyframes animatetop {
    from {bottom: -500px}
    to {bottom: 0}
`
